import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'

import BootstrapVue from 'bootstrap-vue'

import globals from './globals'
import Popper from 'popper.js'
import IdleVue from 'idle-vue'

const eventsHub = new Vue()

// Session Timeout
// 900000 - 15 minutes
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 900000,
  startAtIdle: false
})

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
